<script>
  import { createEventDispatcher,onMount } from "svelte";
  import wrappedFetch from  '../wrappedFetch.js';
  let dispatch = createEventDispatcher();
  let homepageText = '';
  
  export let isLoading;        // declare the prop
  export let showInstallHelp;  // declare the prop
const getContent = async () => {
    const getHelpContents = await wrappedFetch("helpcontent?helpId=home");
    return await getHelpContents.json();
  };
  onMount(async()=>{
    let contents = await getContent();
    contents.find(c => { if(c.type=='h2')  homepageText = c.text; });;
  })

</script>

<svelte:head>
  <title>Home | eAdmissions</title>
</svelte:head>
<section class="section">
  <div class="container">
    <div class="tile is-parent" style="padding: 0rem;">
      <article aria-label="welcome header"
        class="tile is-child notification"
        style="background-color: transparent;">
        <h1 class="title" style="text-align: center;color: #70457a;">
          Welcome to eAdmissions
        </h1>
      </article>
    </div>

    <div class="tile is-parent">
      <div class="tile is-vertical is-12">
        <div class="tile">
          <div tabindex="0" role='button' 
            class="tile is-parent is-vertical tile-hover"
            aria-label="First time users"
            on:click={() => dispatch('pageChange', '/register/start')}
            on:keypress={(e) => {if(e.keyCode == 13) dispatch('pageChange', '/register/start')}}>
            <article class="tile is-child home-button notification is-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="60"
                height="60"
                viewBox="0 0 172 172"
                style=" fill:#000000; float:right;">
                <g transform="">
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal">
                    <path d="M0,172v-172h172v172z" fill="none" />
                    <g fill="#ffffff">
                      <path
                        d="M69.46154,1.03365c-19.94952,0 -35.97115,13.69592
                        -35.97115,39.89904c0,17.10697 6.82212,34.54988
                        17.15865,45.27404c4.03125,10.72416 -3.23017,14.72957
                        -4.75481,15.29808c-20.87981,7.64904 -45.27404,21.55169
                        -45.27404,35.35096v5.16827c0,18.8125 35.81611,23.15385
                        69.04808,23.15385c7.28726,0 14.60036,-0.3101
                        21.70673,-0.82692c-8.73437,-9.2512 -14.05769,-21.62921
                        -14.05769,-35.35096c0,-11.83533 4.03125,-22.71454
                        10.75,-31.42308c-1.00781,-2.32572 -1.39543,-5.99519
                        0.41346,-11.57692c10.28486,-10.75 16.95192,-28.03786
                        16.95192,-45.06731c0,-26.20312 -16.02163,-39.89904
                        -35.97115,-39.89904zM129,87.24038c-23.05048,0
                        -41.75962,18.68329 -41.75962,41.75962c0,23.07632
                        18.68329,41.75962 41.75962,41.75962c23.07632,0
                        41.75962,-18.68329 41.75962,-41.75962c0,-23.07632
                        -18.70913,-41.75962
                        -41.75962,-41.75962zM123.21154,105.84615h11.57692v17.15865h17.15865v11.99038h-17.15865v17.15865h-11.57692v-17.15865h-17.36538v-11.99038h17.36538z" />
                    </g>
                    <path d="" fill="none" />
                  </g>
                </g>
              </svg>
              <h2 class="title is-4">First time visitors</h2>
              <p class="subtitle">Create a new account.</p>
              <p style="text-decoration:underline;margin-bottom:0px;">
                Register
              </p>
            </article>

          </div>
          <div tabindex="0" role='button' 
            class="tile is-parent tile-hover"
            aria-label="Returning users"
            on:click={() => dispatch('pageChange', '/signin')}
            on:keypress={(e) => {if(e.keyCode == 13) dispatch('pageChange', '/signin')}}>
            <article
              class="tile is-child home-button notification"
              style="background-color: #416EA1;color: white;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="60"
                height="60"
                viewBox="0 0 24 24"
                style=" fill:#ffffff; float: right;">
                <path
                  d="M 12 1 C 9.5425419 1 7.4302219 2.5041568 6.5 4.6484375 A
                  1.0001 1.0001 0 1 0 8.3339844 5.4433594 C 8.9637625 3.9916401
                  10.353458 3 12 3 C 14.27619 3 16 4.7238095 16 7 L 16 8 L 6 8 C
                  4.9 8 4 8.9 4 10 L 4 20 C 4 21.1 4.9 22 6 22 L 18 22 C 19.1 22
                  20 21.1 20 20 L 20 10 C 20 8.9 19.1 8 18 8 L 18 7 C 18
                  3.6761905 15.32381 1 12 1 z M 12 13 C 13.1 13 14 13.9 14 15 C
                  14 16.1 13.1 17 12 17 C 10.9 17 10 16.1 10 15 C 10 13.9 10.9
                  13 12 13 z" />
              </svg>
              <h2 class="title is-4">Existing Account</h2>
              <p class="subtitle">Sign into an existing account.</p>
              <p><small>Please note: Accounts on the eAdmissions website may be archived / deleted if not used in the last 3 years. Sign in to see if your account is still available.</small>
              <p style="text-decoration:underline;margin-bottom:0px;">
                Sign in
              </p>

            </article>
          </div>
          <div tabindex="0" role='button' 
            class="tile is-parent tile-hover"
            aria-label="Find schools"
            on:click={() => dispatch('pageChange', '/findschools')} 
            on:keypress={(e) => {if(e.keyCode == 13) dispatch('pageChange', '/findschools')}}>

            <article
              class="tile is-child home-button notification"
              style="background-color: #666666; color:white;">            
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="60"
                  height="60"
                  viewBox="0 0 172 172"
                  style=" fill:#000000; float: right;">
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal">
                    <path d="M0,172v-172h172v172z" fill="none" />
                    <g fill="#ffffff">
                      <path
                        d="M86,14.33333c-27.70633,0 -50.16667,22.46033
                        -50.16667,50.16667c0,35.83333 50.16667,93.16667
                        50.16667,93.16667c0,0 50.16667,-57.33333
                        50.16667,-93.16667c0,-27.70633 -22.46033,-50.16667
                        -50.16667,-50.16667zM86,82.41667c-9.89717,0
                        -17.91667,-8.0195 -17.91667,-17.91667c0,-9.89717
                        8.0195,-17.91667 17.91667,-17.91667c9.89717,0
                        17.91667,8.0195 17.91667,17.91667c0,9.89717
                        -8.0195,17.91667 -17.91667,17.91667z" />
                    </g>
                  </g>
                </svg>

                <h2 class="title is-4">Find schools</h2>
                <p class="subtitle">In your area.</p>
                <p style="text-decoration:underline;margin-bottom:0px;">
                  Find
                </p>            
            </article>
          </div>

        </div>
        <div class="tile is-parent">
          <article
            aria-label="Information"
            class="tile is-child notification"
            style="background-color: #407f8a;color: white;">
            <p class="title is-4">Important information</p>
            <div class="content">
            {#if homepageText!=''}
            {@html homepageText}
            {/if}            
            </div>
          </article>
        </div>

      </div>

    </div>

  </div>
</section>
